module.exports = __webpack_public_path__ + "static/media/U1-T2-1-1a.40378250.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vo/U1-T2-1-1a.mp3
// module id = 501
// module chunks = 0